import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Members`}</p>
    <dl>
      <dt><a href="#hooks">hooks</a> : <inlineCode>tapable.AsyncSeriesHook</inlineCode></dt>
      <dd>
        <p>{`Provides access to Peregrine React hooks.`}</p>
        <p>{`This target collects requests to intercept and "wrap" individual Peregrine
hooks in decorator functions.`}</p>
        <p>{`Use this target to run custom code whenever the application calls a
Peregrine hook.
You can also use this target to modify the behavior or output returned by
a hook.`}</p>
      </dd>
      <dt><a href="#talons">talons</a> : <inlineCode>tapable.AsyncSeriesHook</inlineCode></dt>
      <dd>
        <p>{`Provides access to Peregrine talon wrappers.`}</p>
        <p>{`This target collects requests to intercept and "wrap" individual Peregrine
talons in decorator functions.`}</p>
        <p>{`Use this target to run custom code whenever the application calls a
Peregrine talon.
You can also use this target to modify the behavior or output returned by
a talon.`}</p>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#hookInterceptFunction">hookInterceptFunction</a> : <inlineCode>function</inlineCode></dt>
      <dd>
        <p>{`Intercept function signature for the `}<inlineCode parentName="p">{`talons`}</inlineCode>{` and `}<inlineCode parentName="p">{`hooks`}</inlineCode>{` targets.`}</p>
        <p>{`Interceptors of `}<inlineCode parentName="p">{`hooks`}</inlineCode>{` should call `}<inlineCode parentName="p">{`wrapWith`}</inlineCode>{` on the individual hooks in
the provided `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/pwa-studio/tutorials/targets/modify-talon-results/"
          }}><inlineCode parentName="a">{`HookInterceptorSet`}</inlineCode>{` object`}</a>{`.`}</p>
      </dd>
    </dl>
    <p>{`Provides access to Peregrine React hooks.`}</p>
    <p>{`This target collects requests to intercept and "wrap" individual Peregrine
hooks in decorator functions.`}</p>
    <p>{`Use this target to run custom code whenever the application calls a
Peregrine hook.
You can also use this target to modify the behavior or output returned by
a hook.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "#hookInterceptFunction"
      }}>{`Intercept function signature`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Access the tapable object)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const peregrineTargets = targets.of('@magento/peregrine');
const hooksTarget = peregrineTargets.hooks;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Wrap the `}{`\``}{`useAwaitQuery()`}{`\``}{` hook  with a logging extension)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`
hooksTargets.tap( => {
  hook.useAwaitQuery.wrapWith('@my-extensions/log-wrapper');
})
`}</code></pre>
    <p>{`Provides access to Peregrine talon wrappers.`}</p>
    <p>{`This target collects requests to intercept and "wrap" individual Peregrine
talons in decorator functions.`}</p>
    <p>{`Use this target to run custom code whenever the application calls a
Peregrine talon.
You can also use this target to modify the behavior or output returned by
a talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "#hookInterceptFunction"
      }}>{`Intercept function signature`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Access the tapable object)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const peregrineTargets = targets.of('@magento/peregrine');
const talonsTarget = peregrineTargets.talons;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Wrap the `}{`\``}{`useApp()`}{`\``}{` hook  with a logging extension)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`
talonsTarget.tap(talons => {
  talons.App.useApp.wrapWith('@my-extensions/log-wrapper');
})
`}</code></pre>
    <p>{`Intercept function signature for the `}<inlineCode parentName="p">{`talons`}</inlineCode>{` and `}<inlineCode parentName="p">{`hooks`}</inlineCode>{` targets.`}</p>
    <p>{`Interceptors of `}<inlineCode parentName="p">{`hooks`}</inlineCode>{` should call `}<inlineCode parentName="p">{`wrapWith`}</inlineCode>{` on the individual hooks in
the provided `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/pwa-studio/tutorials/targets/modify-talon-results/"
      }}><inlineCode parentName="a">{`HookInterceptorSet`}</inlineCode>{` object`}</a>{`.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hookInterceptors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`HookInterceptorSet`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Registry of wrappable hook namespaces`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/targets/peregrine-declare.js"
      }}>{`pwa-studio/packages/peregrine/lib/targets/peregrine-declare.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      